import {
  IDynamicDataConfig,
  IDynamicDataSectionConfig,
  IDynamicReferencedThing
} from "~/interfaces/dynamicFieldsInterfaces";
import {Constructor} from "../../../../global/constructor";
import {DynamicReferenceType} from "~/enums/dynamicReferenceType";
import Formula from "~/models/formula";

export default function FormSubmissionMetadataDynamicFieldsHandlerMixin<TBase extends Constructor>(Base: TBase) {
  return class FormSubmissionMetadataDynamicFieldsHandler extends Base {
    static readonly SUBMISSION_ID_ID = Formula.buildDynamicId({id: '1', dynamicReferenceType: DynamicReferenceType.SubmissionId});
    static readonly SUBMISSION_ID_LABEL = 'Submission ID';

    hasSubmissionIdMatch(q: string): boolean {
      return FormSubmissionMetadataDynamicFieldsHandler.SUBMISSION_ID_LABEL.toLowerCase().match(q) !== null;
    }

    submissionIdSections(q: string): IDynamicDataSectionConfig[] {
      return [
        {
          type: DynamicReferenceType.SubmissionId,
          id: FormSubmissionMetadataDynamicFieldsHandler.SUBMISSION_ID_ID,
          label: FormSubmissionMetadataDynamicFieldsHandler.SUBMISSION_ID_LABEL,
          select: this.selectSubmissionId.bind(this),
        },
      ].filter(section => section.label.toLowerCase().match(q) !== null);
    }

    selectSubmissionId(): IDynamicReferencedThing {
      return {
        type: DynamicReferenceType.SubmissionId,
        id: FormSubmissionMetadataDynamicFieldsHandler.SUBMISSION_ID_ID,
        label: FormSubmissionMetadataDynamicFieldsHandler.SUBMISSION_ID_LABEL,
      };
    }
  }
}
